import {
  IconButton, MenuItem, Typography,
} from '@mui/material';
import { toInteger } from 'lodash';
import styled from 'styled-components';

const DropdownContainer = styled.div`
    position: relative;
`;

const Dropdown = styled.ul`
  && {
    width: 100%;
    padding: 0px;
    margin-top: ${({ theme }) => theme.spacing(1)};
    margin-bottom: 0px;
    padding-top: ${({ theme }) => theme.spacing(2)};
    padding-bottom: ${({ theme }) => theme.spacing(2)};
    border-radius: ${({ theme }) => (toInteger(theme.shape.borderRadius) * 2)}px;
    background-color: ${({ theme }) => theme.palette.backdrop.main};
    font-weight: 600;
    position: absolute;
    z-index: ${({ theme }) => theme.zIndex.fab + 1};
    & .MuiOutlinedInput-notchedOutline {
      border: none;
    };
  }
`;

const DropdownContents = styled.div`
    overflow-y: scroll;
    max-height: 240px;
`;

const DropdownItem = styled(MenuItem)`
  && {
    display: flex;
    justify-content: left;
  }
`;

const LoadingText = styled(Typography)`
    && {
        padding-left: ${({ theme }) => theme.spacing(2)};
        color: ${({ theme }) => theme.palette.gray.light};
    }
`;

interface Expand {
  $expand: boolean;
}

const ExpandContainer = styled.div<Expand>`
  && {
    width: ${({ $expand }) => ($expand ? '100%' : '0px')};
    opacity: ${({ $expand }) => ($expand ? '1' : '0')};
    transition: width 0.3s, opacity 0.3s;
  }
`;

const TopContainer = styled.div`
  display: flex;
`;

const SearchButton = styled(IconButton)<Expand>`
  && {
    width: ${({ $expand }) => ($expand ? '0px' : 'auto')};
    opacity: ${({ $expand }) => ($expand ? '0' : '1')};
    transition: width 0.3s, opacity 0.3s;
  }
`;

export { Dropdown,
  DropdownItem,
  LoadingText,
  SearchButton,
  DropdownContents,
  TopContainer,
  DropdownContainer,
  ExpandContainer };
